import { ChevronRight, BellOff, Bell, MapPin, RefreshCw } from '@/components/icons'
import { Sun, Moon, Monitor } from 'lucide-react'
import { TopBarBackButton } from './topbar/TopBarBackButton'
import { Card } from './ui/card'
import { MenuItem } from './ui/menu-item'
import { useNavigate } from '@tanstack/react-router'
import { useTheme } from './theme-provider'

const themeOptions = [
  { value: 'light' as const, label: 'Light', icon: Sun },
  { value: 'dark' as const, label: 'Dark', icon: Moon },
  { value: 'system' as const, label: 'System', icon: Monitor },
]

export function Settings() {
  const navigate = useNavigate()
  const { theme, setTheme } = useTheme()

  const currentTheme = themeOptions.find((t) => t.value === theme) ?? themeOptions[2]
  const nextTheme = themeOptions[(themeOptions.indexOf(currentTheme) + 1) % themeOptions.length]

  return (
    <>
      <TopBarBackButton title="Settings" />

      <Card className="flex flex-col gap-2 w-full px-2">
        <MenuItem
          leftIcon={<currentTheme.icon />}
          rightIcon={<nextTheme.icon className="text-content-primary-subtle" />}
          secondaryText={currentTheme.label}
          size="large"
          onClick={() => setTheme(nextTheme.value)}
        >
          Appearance
        </MenuItem>
        <hr className="border-border-L1" />
        <MenuItem
          leftIcon={<BellOff />}
          rightIcon={<ChevronRight />}
          secondaryText="Off"
          size="large"
          onClick={() => navigate({ to: '/settings/donotdisturb' })}
        >
          Do Not Disturb
        </MenuItem>
        <hr className="border-border-L1" />
        <MenuItem
          leftIcon={<Bell />}
          rightIcon={<ChevronRight />}
          secondaryText="Manage"
          size="large"
          onClick={() => navigate({ to: '/settings/notifications' })}
        >
          Notifications
        </MenuItem>
        <hr className="border-border-L1" />
        <MenuItem
          leftIcon={<MapPin />}
          rightIcon={<ChevronRight />}
          secondaryText="Time, temperature"
          size="large"
          onClick={() => navigate({ to: '/settings/regional' })}
        >
          Regional
        </MenuItem>
      </Card>
    </>
  )
}
